const userColumns = [
  {
    title: '用户名',
    dataIndex: 'username',
    key: 'username'
  },
  {
    title: '姓名',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: '公司',
    dataIndex: 'companyName',
    key: 'companyName'
  },
  {
    title: '公司地址',
    dataIndex: 'address',
    key: 'address'
  }
]

export {
  userColumns
}
